import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Typography, PolicyRow } from 'components/alf-design';

const AccountSecurityCard = ({
  userEmail,
  isAdmin,
  onUpdateUsername,
  onResetPassword,
  onLogOut,
}) => (
  <Card>
    <Typography
      type="h2"
      component="h2"
      id="account-security-heading"
      className="mb-[24px] !text-legacy-textDarkSecondary"
    >
      Account Security
    </Typography>

    <div className="mb-[24px]">
      <PolicyRow label="Username" value={userEmail || '—'} vertical />
      <Button
        type="secondary"
        id="update-username"
        data-dd-action-name="profile.account_security.update_username"
        className="mt-[16px]"
        fullWidth
        onClick={onUpdateUsername}
        disabled={isAdmin}
      >
        Update Username
      </Button>
    </div>

    <div>
      <Typography type="caption1" component="div" className="mb-[4px]">
        Password
      </Typography>
      <Typography component="p" className="mb-[16px] font-mono tracking-widest">
        ••••••••••
      </Typography>
      <Button
        type="secondary"
        id="reset-password"
        data-dd-action-name="profile.account_security.reset_password"
        htmlType="button"
        fullWidth
        onClick={onResetPassword}
      >
        Reset Password
      </Button>
    </div>

    <Button
      type="tertiary"
      id="profile-log-out"
      data-dd-action-name="profile.account_security.log_out"
      className="mt-[24px]"
      fullWidth
      onClick={onLogOut}
    >
      Log Out
    </Button>
  </Card>
);

AccountSecurityCard.propTypes = {
  userEmail: PropTypes.string,
  isAdmin: PropTypes.bool.isRequired,
  onUpdateUsername: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  onLogOut: PropTypes.func.isRequired,
};

export default AccountSecurityCard;
